<template>
  <div style="margin: 0px -16px">
    <register2-f-a v-if="!authenticators.length" :token="token" :user="user" />
    <div v-else>
      <v-tabs v-model="tab" :show-arrows="false" grow :mobile-breakpoint="0">
        <v-tab v-for="tab in filteredTabs" :key="tab.key" :tab-value="tab.key">
          {{ tab.title }}
        </v-tab>

        <v-tabs-items v-model="tab" class="mx-4">
          <v-tab-item
            v-for="tab in filteredTabs"
            :key="tab.key"
            :value="tab.key"
          >
            <component
              :is="tab.component"
              :authenticator="tab.key"
              :token="token"
              :user="user"
              @success="redirect"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <v-btn text small class="mt-2" :disabled="loading" @click="cancel">
        Cancelar
      </v-btn>
    </div>
  </div>
</template>

<script>
import Register2FA from "./Register2FA.vue";
import TOTPAuth from "./auth/TOTPAuth.vue";
import WebAuthnAuth from "./auth/WebAuthnAuth.vue";

export default {
  components: {
    Register2FA,
    TOTPAuth,
    WebAuthnAuth,
  },
  data() {
    return {
      tab: null,
      loading: false,
      tabs: [
        {
          key: "WEBAUTHN",
          title: "Chave de Segurança",
          component: "WebAuthnAuth",
        },
        {
          key: "TOTP",
          title: "Token",
          component: "TOTPAuth",
        },
      ],
    };
  },
  methods: {
    cancel() {
      this.$router.go();
    },
    redirect() {
      let to = this.$route.query.redirect || "/";
      this.$router.push(to);
    },
  },
  computed: {
    filteredTabs() {
      return this.tabs.filter((tab) => this.authenticators.includes(tab.key));
    },
  },
  props: {
    authenticators: {
      type: Array,
      default: () => [],
    },
    token: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style>
.v-slide-group__prev,
.v-slide-group__next {
  display: none;
}
</style>
